/* cc-motion.js - 2026-09-26. Reveals [data-reveal] blocks and settles
   [data-cc-parallax] images as they come into view.

   Nothing is hidden up front. The first IntersectionObserver report for an
   element arrives after layout is final (the section stylesheets load in
   the body, so an early getBoundingClientRect is unreliable): anything on
   screen then is simply left visible; only what is genuinely below the
   fold is hidden - instantly, with no transition - and rises in later.
   No scroll listeners, nothing on window, the page scrolls natively. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('cc-motion-ready');
  var seen = new WeakSet();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (!seen.has(el)) {
        seen.add(el);
        if (e.isIntersecting) { el.classList.add('is-in'); io.unobserve(el); return; }
        el.classList.add('cc-pre');                 /* below the fold: hide, no animation */
        return;
      }
      if (!e.isIntersecting) return;
      el.classList.add('cc-go');                    /* transition on ... */
      requestAnimationFrame(function () {
        el.classList.remove('cc-pre');              /* ... then reveal */
        el.classList.add('is-in');
      });
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  function arm() {
    document.querySelectorAll('[data-reveal]:not(.is-in), [data-cc-parallax]:not(.is-in)').forEach(function (el) {
      if (!seen.has(el)) io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  window.ccMotionArm = arm;   /* content added later (quick view, pagination) */
})();
